import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';


@Component({
  selector: 'app-process-oee-kpis',
  templateUrl: './process-oee-kpis.component.html',
  styleUrls: ['./process-oee-kpis.component.css']
})

export class ProcessOeeKpisComponent  implements OnInit{

 form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    value4: new FormControl(''),
    value5: new FormControl(''),
    } )

  } 
  plantAva(n1,n2){
    var plAva=n1/n2;
    var plAvapercent= plAva*100;
    var plAvasimple= plAvapercent.toFixed(2);
    return plAvasimple ;
    }
  quality(n3,n4){
    var qua=(n3-n4)/n3;
    var quaPercent= qua*100;
    var qualitySimple= quaPercent.toFixed(2);
    return qualitySimple ; 
    }
  performance(n1,n3,n5){
    var per=(n3*n5)/n1;
    var perPercent= per*100;
    var perSimple= perPercent.toFixed(2);
    return perSimple ; 
    }
  oee(n1,n2,n3,n4,n5){
    var oee1= (n1/n2);
    var oee2= (n3-n4)/n3;
    var oee3= (n3*n5)/n1;
    var oeeMid = oee1 * oee2 ;
    var oeeValue = oeeMid * oee3 ;
    var oeePercent = oeeValue * 100 ;
    var oeeSimple= oeePercent.toFixed(2);
    return oeeSimple ;
    }
}


// WEBPACK FOOTER //
// C:/my-dream-app/src/app/process-oee-kpis/process-oee-kpis.component.ts